import { useMutation, useQueryClient } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import {
  apiErrorHandler,
  getBackendErrorMessage,
} from "@/core/api/api-error-handler";
import {
  invalidateAfterMutation,
  ledgerProductCodeCacheKeys,
} from "@/core/api/invalidate-after-mutation";
import { logger } from "@/core/utils/func/logger";
import { ledgerEndpoints } from "@/features/ledger/api/endpoints";
import type { ProductCodeDto } from "@/features/ledger/api/dto";

/**
 * Crée un code produit rattaché à une catégorie (`POST /ProductCodes/add`) —
 * réservé à flashpay-superadmin / flashpay-admin.
 */
export const useCreateProductCode = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["ledger", "product-codes", "create"],
    mutationFn: (body: ProductCodeDto) =>
      mutateData({
        url: ledgerEndpoints.productCodes.add,
        reqBody: body as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<ProductCodeDto>,
    onSuccess: () => {
      return invalidateAfterMutation(
        queryClient,
        ledgerProductCodeCacheKeys(),
        { resetListPage: true }
      );
    },
    onError: (error) => {
      const message = getBackendErrorMessage(error) ?? apiErrorHandler(error);
      logger.error(
        `useCreateProductCode failed: ${message}`,
        error instanceof Error ? error : undefined,
        { prefix: "ledger" }
      );
    },
  });
};
